import MissingCountryFlag from "@assets/icons/missing-country-flag.svg";
import { isNotNil } from "@utils/assert";
import CountryIcons, { Props as CountryFlagProps } from "country-flag-icons/react/3x2";
import React from "react";

interface CustomCountryFlagProps extends CountryFlagProps {
	code: string | undefined;
}

export const CountryFlag = ({ code, ...otherProps }: CustomCountryFlagProps): JSX.Element => {
	const Icon =
		isNotNil(code) && code in CountryIcons ? CountryIcons[code as keyof typeof CountryIcons] : MissingCountryFlag;
	return <Icon {...otherProps} />;
};
